import { useAuth } from '../context';
import { AuthState } from '../enum';
import { AppUser } from '../models';
import { getPermissions } from '../utils';

export const useCognitoUser = (): AppUser => {
  const auth = useAuth();

  /* istanbul ignore next */
  if (
    !(auth.state === AuthState.SignedIn || auth.state === AuthState.VerifyEmail)
  ) {
    throw Error(
      'useCognitoUser hook can only be used in SignedIn and VerifyEmail auth states'
    );
  }

  const { cognitoUser } = auth;
  const role =
    cognitoUser.signInUserSession.getIdToken().payload['cognito:groups'][0];

  return {
    id: cognitoUser.username,
    email: cognitoUser.attributes.email,
    name: cognitoUser.attributes.name,
    role,
    permissions: getPermissions(role),
  };
};
